module.exports = __webpack_public_path__ + "static/media/dashboard.360486fe.svg";